var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 223.42 248.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9e4623;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: #820e0e;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 165.02,
    cy: 120.7,
    fx: 165.02,
    fy: 120.7,
    r: 18.95,
    gradientTransform: "translate(-178.83 -11.26) rotate(-42.39) scale(1 2.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#820e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e4623"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.98,1.97c32.04,19.12,64.63,37.79,95.44,58.93-.42-.61-.91-.88-1.46-.81,13.02,11.69,27.84,20.35,33.67,37.6,8.66,25.62,10.5,53.17,16.78,79.39,1.74,7.28,3.61,14.5,5.08,21.86,1.34,6.71,1.29,13.97,2.93,20.51-4.86,3.44-9.41,3.78-14.9,5.5-3.51,1.1-8,2.72-10.92,5.09-5.72,4.63-3.31,7.18-11.4,10.94-12.97,6.04-19.23,1.55-31.76-.38-9.79-1.51-15.34,4.98-24.06,7.21-6.4,1.64-5.49-1.37-7.25-7.42-2.66-9.13-5.66-18.45-6.98-27.89-2.19-15.65-3.45-31.86-9.66-46.59-4.91-11.66-15.25-16.71-27.04-19.98-14.88-4.14-29.9-7.19-44.57-12.27-8.36-2.9-19.11-5.13-26.84-9.48C5.4,122.67.1,119.21,0,116.1c-.01-.4,1.76-1.82,1.93-2.42,1.07-3.93,3.03-7.14,2.38-11.44-1.17-7.65-6.12-12.54-1.22-19.43,3.68-5.18,7.2-8.37,8.76-15.09,1.95-8.37.96-16.85,3.94-25.1,2.17-6,4.88-8.32,9.33-12.35s6.7-9.01,9.76-13.99c5.31-8.65,10.52-10.82,19.47-12.81,4.98-1.11,8.89-4.62,13.04-3.1,3.07,1.12,3.43,4.4,3.59,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.63,152.99c1.03.87,2.11,1.67,3.29,2.36,7.61,4.45,19.65,4.93,24.25-4.26,4.16-8.31-1.7-17.74-4.08-25.68-1.19-3.97-1.43-8.04-2.54-11.99-1.5-5.32-5.04-10.79-8.86-14.77-4.47-4.65-9.87-6.55-16.06-5.72-3.84.51-7.7.55-11.17-1.58-2.64-1.62-3.15-3.64-6.36-3.79-.65-.03-1.35.1-1.92.05-.95-1.16-1.99-2.23-3.31-3.06-5.18-3.25-15.45-1.4-18.54,4.17-3.47,6.25,4.08,13.75,7.17,18.7,2.09,3.34,4.35,6.22,5.37,10.09s1.69,8.17,2.85,12.2c1.27,4.4,3.28,8.27,7.91,9.72s8.4,1.57,12.67,4.83c3.4,2.59,6.1,6,9.34,8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.25,92.93c7.91,4.84,15.44,10.16,22.92,15.58,7.3,5.37,15.38,11.2,20.87,18.55,3.8,5.06,6.29,10.64,10.84,14.89-2.67-1.6-4.88-3.9-6.89-6.26-3.84-4.85-7.47-9.54-12.19-13.5-3.91-3.54-10.11-8.1-14.33-11.4-7.26-5.74-14.43-11.55-21.23-17.85h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCut);
export default __webpack_public_path__ + "static/media/cut.1a14933067bbf55d38e5fd486fed464d.svg";
export { ForwardRef as ReactComponent };